export default "__VITE_ASSET__e80a88fd__"